import { IPhraseConstructorArgs } from "./phrase";

export const phraseWithTokens = "This %{who} %{what} %{when}";
export const phraseWithoutTokens = "This who what when";

export const phraseArgs: IPhraseConstructorArgs = {
  msgId: "msgId",
  msgIdPlural: "msgidPlural",
  msgCtxt: "msgCtxt",
  comments: ["comments"],
  msgStr: ["msgStr0", "msgStr1"]
};

export const phraseArgsWithNullMsgStr: IPhraseConstructorArgs = {
  msgId: "msgId",
  msgIdPlural: "msgidPlural",
  msgCtxt: "msgCtxt",
  comments: ["comments"],
  msgStr: null
};

export const phraseArgsWithNullMsgId: IPhraseConstructorArgs = {
  msgId: null,
  msgIdPlural: "msgidPlural",
  msgCtxt: "msgCtxt",
  comments: ["comments"],
  msgStr: ["msgStr0", "msgStr1"]
};

export const phraseArgsWithNullComments: IPhraseConstructorArgs = {
  msgId: "msgId",
  msgIdPlural: "msgidPlural",
  msgCtxt: "msgCtxt",
  comments: null,
  msgStr: ["msgStr0", "msgStr1"]
};

export const phraseArgsWithNullMsgStrAndPlural: IPhraseConstructorArgs = {
  msgId: "msgId",
  msgIdPlural: null,
  msgCtxt: "msgCtxt",
  comments: ["comments"],
  msgStr: null
};
